import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '../../../../components/Intl/withIntl.js';
import Autocomplete from '../../../../components/Autocomplete/Autocomplete';
import { getAvailableCountriesRequest, getCountryNameTranslation } from '../../AddressActions';
import Flag from '../../../../components/Flag/Flag';

function CountrySelector({ intl, country = '', onSelect = null, onFetch = null, inputProps = {} }) {
	const [countries, setCountries] = useState([]);

	const handleSort = countries => {
		const preferred = ['FR', 'BE', 'DE', 'NL'];

		return [
			...preferred.map(cca2 => countries.find(c => c.cca2 === cca2)),
			...countries.filter(c => !preferred.includes(c.cca2)),
		];
	};

	// Search for country data from input value, and set it (prevent user not selecting in list)
	const handleSetCountryData = value => {
		if((value || '').length > 3) {
			let selectedCountries = countries.filter(country => country?.cca2?.toLowerCase().trim() === (value || '').toLowerCase().trim());
			if(!selectedCountries.length) {
				selectedCountries = countries.filter(country => (
					country?.name?.common.toLowerCase().trim() === (value || '').toLowerCase().trim()
					|| Object.entries(country.translations || {}).some(translation => translation[1].common?.toLowerCase().indexOf((value || '').toLowerCase().trim()) !== -1)
				));
			}
			// console.log('Auto select country from input value', selectedCountries);
			selectedCountries.length === 1 && onSelect && onSelect(selectedCountries[0]);
		}
	};

	useEffect(() => {
		getAvailableCountriesRequest().then(countries => {
            setCountries([...handleSort(countries), 'S1']);
        });
	}, []);

	useEffect(() => {
		onFetch && onFetch(countries);
	}, [countries]);

	return (
		<Autocomplete
			items={(countries || [])}
			getItemValue={item => getCountryNameTranslation(item, intl.locale)}
			// getItemLabel={item => getCountryNameTranslation(item, this.props.intl.locale)}
			// filter={(item, search) => }
			value={country}
			onChange={handleSetCountryData}
			onSelect={onSelect}
			renderItem={item => (
				<div>
					<Flag country={item.cca2} /> {getCountryNameTranslation(item, intl.locale)}
				</div>
			)}
			inputProps={{
				placeholder: intl.formatMessage({ id: 'addressCountry', defaultMessage: 'Country' }),
				...inputProps,
			}}
		/>
	);
}

CountrySelector.propTypes = {
	intl: PropTypes.object.isRequired,
	country: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
	onFetch: PropTypes.func,
	hasError: PropTypes.bool,
	inputProps: PropTypes.object,
};

export default injectIntl(CountrySelector);
